const WARNING_BANNER_ID = 'order-form-warning-banner';

window.B2BOrderForm.ErrorManager = {
  /**
   * Displays the warning banner with optional title, description, CTA link, and technical error details.
   * @param {Object} options
   * @param {string} [options.title] - Heading text for the banner.
   * @param {string} [options.description] - Body text shown below the title.
   * @param {string} [options.ctaText] - Label for the call-to-action link.
   * @param {string} [options.ctaUrl] - URL for the call-to-action link.
   * @param {string} [options.detailsNote] - Optional note shown at the bottom of the technical details panel.
   * @param {*} [options.error] - Raw error value; populates the technical details accordion.
   */
  showWarningBanner(options = {}) {
    const el = document.getElementById(WARNING_BANNER_ID);
    if (!el) { return; }

    if (options.title !== undefined) {
      el.querySelector(`.${WARNING_BANNER_ID}__title`).textContent = options.title;
    }

    const descEl = el.querySelector(`.${WARNING_BANNER_ID}__description`);
    if (options.description !== undefined) {
      descEl.textContent = options.description;
      descEl.style.display = '';
    }

    const ctaEl = el.querySelector(`.${WARNING_BANNER_ID}__cta`);
    if (options.ctaText !== undefined && options.ctaUrl !== undefined) {
      ctaEl.textContent = options.ctaText;
      ctaEl.href = options.ctaUrl;
      ctaEl.style.display = '';
    }

    const detailsEl = el.querySelector(`.${WARNING_BANNER_ID}__details`);
    if (options.error !== undefined && detailsEl) {
      const details = extractErrorDetails(options.error);
      el.querySelector(`.${WARNING_BANNER_ID}__details-error-summary`).textContent = details.summary;
      el.querySelector(`.${WARNING_BANNER_ID}__details-timestamp`).textContent = details.timestamp;

      const noteEl = el.querySelector(`.${WARNING_BANNER_ID}__details-note`);
      if (options.detailsNote) {
        noteEl.textContent = options.detailsNote;
        noteEl.style.display = '';
      } else {
        noteEl.style.display = 'none';
      }

      detailsEl.style.display = '';
      detailsEl.open = false;
    } else if (detailsEl) {
      detailsEl.style.display = 'none';
    }

    el.style.display = 'flex';
  },

  /** Hides the warning banner. */
  hideWarningBanner() {
    const el = document.getElementById(WARNING_BANNER_ID);
    if (el) { el.style.display = 'none'; }
  },

  /**
   * Disables the search input and swaps the search icon for a lock icon to
   * signal that search is unavailable.
   */
  disableSearch() {
    const container = document.querySelector('.order-form-search-bar-container');
    const input = document.getElementById('order-form-search-bar');
    const searchIcon = document.getElementById('order-form-search-icon');
    const lockIcon = document.getElementById('order-form-lock-icon');

    if (!input) { return; }

    if (container) { container.classList.add('order-form-search-bar-container--disabled'); }
    input.disabled = true;
    input.placeholder = 'Search is unavailable ...';

    if (searchIcon) { searchIcon.style.display = 'none'; }
    if (lockIcon) { lockIcon.style.display = ''; }
  },

  /**
   * Re-enables the search input and restores the search icon. Included for
   * completeness — in practice search errors are not recoverable without a
   * page reload, so this is unlikely to be called.
   */
  enableSearch() {
    const container = document.querySelector('.order-form-search-bar-container');
    const input = document.getElementById('order-form-search-bar');
    const searchIcon = document.getElementById('order-form-search-icon');
    const lockIcon = document.getElementById('order-form-lock-icon');

    if (!input) { return; }

    if (container) { container.classList.remove('order-form-search-bar-container--disabled'); }
    input.disabled = false;
    input.placeholder = 'Search products...';

    if (searchIcon) { searchIcon.style.display = ''; }
    if (lockIcon) { lockIcon.style.display = 'none'; }
  },
};

function extractErrorDetails(error) {
  const d = new Date();
  const dateStr = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', timeZone: 'UTC' });
  const timestamp = `${dateStr} – ${timeStr} UTC`;

  let summary = 'An unexpected error occurred.';

  if (typeof error === 'string') {
    summary = error;
  } else if (error instanceof Error) {
    summary = error.message;
    if (error.cause instanceof Error) { summary += ` — ${error.cause.message}`; }
    else if (error.cause != null) { summary += ` — ${String(error.cause)}`; }
  } else if (Array.isArray(error)) {
    const firstError = error[0];
    if (firstError?.message) { summary = firstError.message; }
  }

  return { summary, timestamp };
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById(WARNING_BANNER_ID);
  if (!el) { return; }

  el.querySelector(`.${WARNING_BANNER_ID}__close`).addEventListener('click', () => {
    window.B2BOrderForm.ErrorManager.hideWarningBanner();
  });

  el.querySelector(`.${WARNING_BANNER_ID}__copy-btn`).addEventListener('click', () => {
    const copyBtn = el.querySelector(`.${WARNING_BANNER_ID}__copy-btn`);
    const rows = [
      ['Error summary', `.${WARNING_BANNER_ID}__details-error-summary`],
      ['Timestamp (UTC)', `.${WARNING_BANNER_ID}__details-timestamp`],
    ];
    const text = rows
      .map(([label, selector]) => `${label}: ${el.querySelector(selector)?.textContent ?? ''}`)
      .join('\n');

    navigator.clipboard.writeText(text).then(() => {
      copyBtn.querySelector('span').textContent = 'Copied!';
      setTimeout(() => { copyBtn.querySelector('span').textContent = 'Copy details'; }, 2000);
    });
  });
}, { once: true });
